<template>
    <div class="form-submit">
        <component
                class="form-submit--wrap"
                ref="recaptcha"
                :is="recaptchaComponent.is"
                v-bind="recaptchaComponent"
                @render="onRecaptchaRendered($event)"
                @expired="onRecaptchaExpired($event)"
                @verify="onRecaptchaVerified($event)">
            <loader-btn
                    class="form-submit--btn"
                    type="submit"
                    :is-loading="isLoading"
                    :btn-facets="btnFacets"
                    @click.native="onVerify">
                <span class="btn--wrap">
                    <span class="btn--text">
                        {{ label }}
                    </span>
                </span>
            </loader-btn>
        </component>
        <form-field-messages :messages="messages"/>
    </div>
</template>

<script>
    import VueRecaptcha from 'vue-recaptcha';
    import bemMixin from 'framework/mixins/bem/index';
    import isMountedMixin from 'framework/mixins/is-mounted/index';
    import FormFieldMessages from 'framework/components/form/form-field-messages/form-field-messages';
    import LoaderBtn from 'framework/components/buttons/loader-btn/loader-btn';

    export default {
        components: {
            LoaderBtn,
            FormFieldMessages,
            VueRecaptcha,
        },
        mixins: [
            bemMixin('form-submit'),
            isMountedMixin,
        ],
        props: {
            useRecaptcha: {
                type: Boolean,
                default: false,
            },
            isLoading: {
                type: Boolean,
                required: true,
            },
            onFormSubmit: {
                type: Function,
                required: true,
            },
            sitekey: {
                type: String,
                required: true,
            },
            label: {
                type: String,
                required: true,
            },
            btnFacets: {
                type: Array,
                required: true,
            },
            /** @type {IFormFieldMessages}*/
            messages: {
                type: Object,
                default() {
                    return {
                        error: [],
                    };
                },
            },
        },
        data() {
            return {
                isVerifying: false,
                isVerified: false,
                widgetId: null,
            };
        },
        computed: {
            recaptchaComponent() {
                return this.useRecaptcha ? {
                    is: 'vue-recaptcha',
                    badge: 'inline',
                    sitekey: this.sitekey,
                } : {
                    is: 'div',
                };
            },
        },
        methods: {
            resetRecaptcha() {
                this.$refs.recaptcha.reset(this.widgetId);
            },
            submitForm() {
                this.isVerifying = false;

                if (!this.isLoading) {
                    this.onFormSubmit();
                    this.onRecaptchaExpired();
                }
            },
            onRecaptchaRendered(widgetId) {
                this.$log.debug('Recaptcha is ready!', widgetId);
                this.widgetId = widgetId;
            },
            onRecaptchaExpired() {
                this.$log.debug('Recaptcha is expired! Resetting...');
                this.isVerified = false;

                this.resetRecaptcha();
            },
            onRecaptchaVerified(response) {
                this.$log.debug('Recaptcha is verified!', response);
                this.isVerified = true;

                this.submitForm();
            },
            onVerify(event) {
                this.isVerifying = true;

                if (this.useRecaptcha) {
                    if (this.isVerified) {
                        this.submitForm();
                    }
                } else {
                    event.preventDefault();
                    event.stopPropagation();
                    this.submitForm();
                }
            },
        },
    };
</script>
